import React from 'react'
import { Tooltip } from '@mui/material'

type Props = {
  disabled?: boolean
  title?: string
  children: React.ReactNode
}

export const DisabledTooltip = ({ disabled, title, children }: Props) => {
  if (!disabled) return <>{children}</>

  return (
    <Tooltip title={title ?? ''} arrow>
      <span>{children}</span>
    </Tooltip>
  )
}

export default DisabledTooltip


